import requests from "./api/base-api";

const Advertisement= {
  getAll: () => requests.get("/advertisement/v1/get-all-advertisements-for-user"),
 
};

export default Advertisement;